module.exports = __webpack_public_path__ + "static/media/goldengate.3a4296a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/goldengate.jpg
// module id = 54
// module chunks = 0